"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RtcCommand_1 = require("../../Engine/Command/RtcCommand");
const FudaoCommand_1 = require("../FudaoCommand");
const FudaoDto_1 = require("../Protocol/FudaoDto");
class FudaoHttpCommandHubAdapter {
    get errorOccurred() { return this._cmdHub.errorOccurred; }
    constructor(fhsu, cmdHub) {
        this._fudaoHttpServiceUri = fhsu;
        this._cmdHub = cmdHub;
    }
    receiveCommand(rtcCmd) {
        this._cmdHub.receiveCommand(rtcCmd);
    }
    async receiveCommandAsync(rtcCmd) {
        await this._cmdHub.receiveCommandAsync(rtcCmd);
    }
    registerCommandHandler(category, handler) {
        this._cmdHub.registerCommandHandler(category, handler);
    }
    unRegisterCommandHandler(category) {
        this._cmdHub.unRegisterCommandHandler(category);
    }
    sendCommand(rtcCmd) {
        this._cmdHub.sendCommand(rtcCmd);
    }
    sendCommands(rtcCmds) {
        this._cmdHub.sendCommands(rtcCmds);
    }
    async sendCommandAsync(originalCmd) {
        let modifiedCmd = originalCmd;
        //把要送給Fudao http服務的Command加上相關資訊再發送
        if (originalCmd.name === FudaoCommand_1.FudaoCommand.TeacherCreateFudao && originalCmd.isToService) {
            modifiedCmd = RtcCommand_1.RtcCommand.Builder(originalCmd)
                .Transport(RtcCommand_1.TransportType.Http)
                .ClearReceiver()
                .AddReceiver(`${this._fudaoHttpServiceUri}/api/fudaos`)
                .AddReceiver("POST")
                .Build();
        }
        else if (originalCmd.name === FudaoCommand_1.FudaoCommand.TeacherStartFudao && originalCmd.isToService) {
            modifiedCmd = RtcCommand_1.RtcCommand.Builder(originalCmd)
                .Transport(RtcCommand_1.TransportType.Http)
                .ClearReceiver()
                .AddReceiver(`${this._fudaoHttpServiceUri}/api/fudaos/${originalCmd.targetId}/start`)
                .AddReceiver("POST")
                .Content({
                fudaoId: originalCmd.targetId
            })
                .Build();
        }
        else if (originalCmd.name === FudaoCommand_1.FudaoCommand.TeacherReportFudaoIsAlive && originalCmd.isToService) {
            const fudaoDto = new FudaoDto_1.FudaoDto(originalCmd.contentTo());
            modifiedCmd = RtcCommand_1.RtcCommand.Builder(originalCmd)
                .Transport(RtcCommand_1.TransportType.Http)
                .ClearReceiver()
                .AddReceiver(`${this._fudaoHttpServiceUri}/api/fudaos/${originalCmd.targetId}/aliveTime`)
                .AddReceiver("PATCH")
                .Content({
                teacherId: fudaoDto.teacher.Id
            })
                .Build();
        }
        else if (originalCmd.name === FudaoCommand_1.FudaoCommand.TeacherExtendFudao && originalCmd.isToService) {
            const lastExtendTimes = originalCmd.contentTo();
            modifiedCmd = RtcCommand_1.RtcCommand.Builder(originalCmd)
                .Transport(RtcCommand_1.TransportType.Http)
                .ClearReceiver()
                .AddReceiver(`${this._fudaoHttpServiceUri}/api/fudaos/${originalCmd.targetId}/extendTimes`)
                .AddReceiver("PATCH")
                .Content({
                "lastExtendTimes": lastExtendTimes.toString()
            })
                .Build();
        }
        else if (originalCmd.name === FudaoCommand_1.FudaoCommand.TeacherEndFudao && originalCmd.isToService) {
            const fudaoDto = new FudaoDto_1.FudaoDto(originalCmd.contentTo());
            const jObj = {
                teacherId: fudaoDto.teacher.Id
            };
            modifiedCmd = RtcCommand_1.RtcCommand.Builder(originalCmd)
                .Transport(RtcCommand_1.TransportType.Http)
                .ClearReceiver()
                .AddReceiver(`${this._fudaoHttpServiceUri}/api/fudaos/${originalCmd.targetId}/end`)
                .AddReceiver("POST")
                .Content(jObj)
                .Build();
        }
        return await this._cmdHub.sendCommandAsync(modifiedCmd);
    }
    async sendCommandsAsync(rtcCmds) {
        return await this._cmdHub.sendCommandsAsync(rtcCmds);
    }
}
exports.FudaoHttpCommandHubAdapter = FudaoHttpCommandHubAdapter;
//# sourceMappingURL=FudaoHttpCommandHubAdapter.js.map